import {Component, Input, ViewChild} from '@angular/core';
import {NavParams, ViewController} from 'ionic-angular';
import {ImageContentForm} from '../../../image/form/image-content.form';
import {ImageCardButtons} from '../../interfaces/image-card-buttons.interface';
import {ImageCardComponent} from '../image-card/image-card.component';

/**
 * Class for the EditImageModalComponent
 * @class
 * @description Modal for editing a content's image metadata
 *
 * # Inputs
 * |name|type|description|
 * |---|---|---|
 * |form|[[ImageContentForm]]|Image form for the image|
 */
@Component({
  selector: 'advtech-edit-image-modal',
  templateUrl: './edit-image-modal.component.html',
})
export class EditImageModalComponent {

  /**
   * Save button
   * @type {ImageCardButtons[]}
   */
  imagePageButtons: ImageCardButtons[] = [{
    label: 'Save',
    handler: (id) => this.imageCardComponent.save(),
    isFull: true,
    cssClass: 'save-button',
  },
  ];

  /**
   * The image form being modified inside our image card
   * @type {ImageContentForm}
   */
  @Input()
  form: ImageContentForm;
  /**
   * The image form structure passed from the upload process
   * @type {{ImageContentForm: any, path: string}}
   */
  imageFormItem: {ImageContentForm: any, path: string};

  /**
   * The image card component within this modal
   * @type {ImageCardComponent}
   */
  @ViewChild('imageCard')
  imageCardComponent: ImageCardComponent;

  /**
   * Array of possible crop gravity values returned from the server
   * @type {Array<object>}
   */
  cropGravityChoices: object[] = [];

  /**
   * @param {NavParams} navParams the NavParams instance
   * @param {ViewController} viewCtrl the ViewController instance
   * @constructor
   */
  constructor(private navParams: NavParams,
              private viewCtrl: ViewController) {
    this.imageFormItem = this.navParams.get('imageFormItem');
    this.cropGravityChoices = this.navParams.get('cropGravityChoices');
  }

  /**
   * Handle the image card component save, pass it to the ArticleComponent
   * @param {any} response The reponse of the image
   * @returns {void}
   */
  onSave(response: any): void {
    this.form = this.imageCardComponent.form;
    this.viewCtrl.dismiss({form: this.form, path: this.imageFormItem.path, data: response.data});
  }

  /**
   * Dismiss the modal when the user hits cancel
   * @returns {void}
   */
  hCancel(): void {
    this.viewCtrl.dismiss();
  }
}


// WEBPACK FOOTER //
// ./src/app/content/shared/components/edit-image-modal/edit-image-modal.component.ts